import { Fragment, useEffect } from 'react'
import SharedFoldersLayout from './SharedFoldersLayout'
import { useAuthState } from 'packages/core'
import useSubcomponents from 'useSubcomponents'
import { usePageContext } from 'pageContext'

const allFilters = [
    {
        name: 'OwnedByFilter',
        requireAccess: 'ResourceAdmin-SharedFolder-Filter-OwnedBy',
    },
    {
        name: 'uncPathFilter',
        requireAccess: 'ResourceAdmin-SharedFolder-Filter-UNCPath',
    },
    {
        name: 'advancedSearch',
        requireAccess: 'ResourceAdmin-SharedFolder-Filter-AdvancedSearch',
        config: {
            title: 'Common_Forms',
            colorCode: {
                primary: '#2920ad',
                secondary: '#ebeaf7',
            },
            filters: [
                {
                    name: 'friendlyName',
                    type: 'text',
                    label: 'Common_Name',
                    placeholder: 'Common_Name',
                    contextProp: 'advancedSearch.forms.friendlyName',
                },
                {
                    name: 'computer',
                    type: 'text',
                    label: 'Computer',
                    placeholder: 'Computer',
                    contextProp: 'advancedSearch.forms.computer',
                },
                {
                    name: 'dnsHostName',
                    type: 'text',
                    label: 'DNSHostName',
                    placeholder: 'DNSHostName',
                    contextProp: 'advancedSearch.forms.dnsHostName',
                },
                {
                    name: 'description',
                    type: 'text',
                    label: 'Common_Description',
                    placeholder: 'Common_Description',
                    contextProp: 'advancedSearch.forms.description',
                },
            ],
            tags: {
                title: 'Common_Tags',
                colorCode: {
                    primary: '#f81983',
                    secondary: '#fee8f2',
                },
                contextProp: 'advancedSearchTags',
            },
        },
    },
]

const RequestViewAllSharedFolders = () => {
    const [, dispatch] = usePageContext()

    const [{ currentUserId, friendlyName }] = useAuthState()

    const { trimControlsBasedOnAccess } = useSubcomponents()

    const filters = trimControlsBasedOnAccess(allFilters)
    const hasOwnedByFilterAccess =
        filters.map((f) => f.name).indexOf('OwnedByFilter') >= 0
    useEffect(() => {
        if (!hasOwnedByFilterAccess) {
            dispatch({
                type: 'SET_MULTIPLE_PROPS',
                payload: {
                    ownedBy: {
                        id: currentUserId,
                        friendlyName: friendlyName,
                    },
                    enableOwnedByApiCall: true,
                },
            })
        } else {
            dispatch({
                type: 'SET_PROP',
                payload: {
                    key: 'enableOwnedByApiCall',
                    value: true,
                },
            })
        }
    }, [currentUserId])
    return (
        <Fragment>
            <SharedFoldersLayout filters={filters} />
        </Fragment>
    )
}

export { RequestViewAllSharedFolders }
